const rackingStatus = (status) => {
  // console.log('fnc rackingStatus: ', status);
  if (status == null) return ''; // cubre null y undefined
  const validStatuses = ['Etiqueta creada', 'Recolectado', 'Entrega actualizada', 'En camino', 'Proceso de Entrega', 'Entregado', 'Excepción', 'Retornado'];
  return validStatuses.includes(status) ? status : 'Entrega actualizada 3';
};
export default rackingStatus;
